export default {
  completedTaskComments: [],
  completedTaskComment: undefined,
};
